/**
 * @file 请求方法基础
 * @author wanzhongyun
 */

import {message} from 'antd';
import request from 'superagent';


const baseRequest = async (superagentObject: Promise<any>): Promise<request.Response> => {
    let res: request.Response;
    try {
        res = await superagentObject;
        const body = res.body;
        if (!body || !body.result) {
            throw new Error('网络好像有点问题');
        }
        if (body.errorCode !== 0) {
            throw new Error(body.errorMsg);
        }
    }
    catch (err: any) {
        (window as any).DEBUG && message.error(err.message);
        throw err;
    }

    return res;
};

export default baseRequest;
